import { AxiosError } from "axios"

import type { IAccountProductWithTransaction, TResponse } from "@pamf-my/types"

import requests from "@/services/requests"

type Response = TResponse<IAccountProductWithTransaction[]>

const SAccountListType = async (signal?: AbortSignal): Promise<Response> => {
  const token = localStorage.getItem("token")
  try {
    const { data } = await requests.get<Response>("/account/list-type", {
      signal,
      headers: {
        Authorization: token ? `Bearer ${token}` : undefined,
      },
    })
    return data
  } catch (error) {
    return (error as AxiosError).response?.data as Response
  }
}

export default SAccountListType
